/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router-dom";
// imported things
import Routes from "./Routes";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Resume from "./components/Resume/resum_e.pdf";
import Loader from "./components/Subassets/loader";
import { AnimatePresence } from "framer-motion";

// resume control
const resumeClick = () => {
  window.open(Resume);
};

// nav objects and functions
const navs = [
  { id: 1, name: "Home", link: "/" },
  { id: 2, name: "About", link: "about" },
  { id: 3, name: "Skills", link: "skills" },
  { id: 4, name: "Work", link: "works" },
  { id: 5, name: "Contact", link: "contact" },
];
function App() {
  const [open, setOpen] = useState(false);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    setloading(true);
    setTimeout(() => {
      setloading(false);
    }, 7000);
  }, []);

  const handleChange = () => {
    setOpen(!open);
  };
  return (
    <HelmetProvider aria-label="title provider">
      <AnimatePresence className="">
        {!loading ? (
          <div
            name="body"
            className="grid justify-center w-full mx-auto bg-slate-800 scroll-smooth"
          >
            <h1 className="sr-only">My Portfolio</h1>
            <Nav
              navs={navs}
              getresume={resumeClick}
              handleChange={handleChange}
              open={open}
            />
            <main aria-label="main section" className="scroll-mt-5">
              <Routes />
            </main>
            <Footer getresume={resumeClick} />
          </div>
        ) : (
          <Loader />
        )}
      </AnimatePresence>
    </HelmetProvider>
  );
}

export default App;
